module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticClass: "shaded m-5",
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.save.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-4",
    class: {
      error: _vm.$v.form.name.$error
    }
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                        Name\n                        "), _c('span', {
    staticClass: "brand"
  }, [_vm._v("\n                            *\n                        ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "name", $event.target.value)
      }, _vm.$v.form.name.$touch]
    }
  })]), _vm._v(" "), (_vm.$v.form.name.$error) ? _c('div', {
    staticClass: "messages"
  }, [(!_vm.$v.form.name.required) ? _c('span', [_vm._v("Name is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.form.name.minLength) ? _c('span', [_vm._v("Name must have at least 3 characters.")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.getShowInvoiceOption) ? _c('div', {
    staticClass: "col-sm-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                        Cost Center\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.code),
      expression: "form.code"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "code", $event.target.value)
      }
    }
  })])]) : _vm._e()]), _vm._v(" "), (_vm.types) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("Type")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "options": _vm.types,
      "placeholder": "- Select resource type -",
      "label": "description"
    },
    on: {
      "input": _vm.updateType
    },
    model: {
      value: (_vm.selectedType),
      callback: function($$v) {
        _vm.selectedType = $$v
      },
      expression: "selectedType"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                        Max. Capacity\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.availability),
      expression: "form.availability"
    }, {
      name: "numInt",
      rawName: "v-numInt"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.availability)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "availability", $event.target.value)
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-9"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                        Description (Optional)\n                        "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.description),
      expression: "form.description"
    }],
    domProps: {
      "value": (_vm.form.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "description", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "mt-5"
  }, [_c('h5', [_vm._v("Resource status")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex mb-3 align-items-center w-100"
  }, [_c('span', {
    staticClass: "fs-small bold mr-2"
  }, [_vm._v("Resource is active:")]), _vm._v(" "), _c('toggle-button', {
    attrs: {
      "labels": {
        checked: 'Yes',
        unchecked: 'No'
      },
      "disabled": false
    },
    model: {
      value: (_vm.form.isActive),
      callback: function($$v) {
        _vm.$set(_vm.form, "isActive", $$v)
      },
      expression: "form.isActive"
    }
  })], 1)])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-e29fc136", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e29fc136"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inventory/resources/ResourceForm.vue
// module id = 2234
// module chunks = 0